/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OverrideJustificationArtefact } from './OverrideJustificationArtefact';
import {
  OverrideJustificationArtefactFromJSON,
  OverrideJustificationArtefactFromJSONTyped,
  OverrideJustificationArtefactToJSON,
} from './OverrideJustificationArtefact';

/**
 *
 * @export
 * @interface PaginatedOverrideJustificationArtefactList
 */
export interface PaginatedOverrideJustificationArtefactList {
  /**
   *
   * @type {number}
   * @memberof PaginatedOverrideJustificationArtefactList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedOverrideJustificationArtefactList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedOverrideJustificationArtefactList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<OverrideJustificationArtefact>}
   * @memberof PaginatedOverrideJustificationArtefactList
   */
  results: Array<OverrideJustificationArtefact>;
}

/**
 * Check if a given object implements the PaginatedOverrideJustificationArtefactList interface.
 */
export function instanceOfPaginatedOverrideJustificationArtefactList(
  value: object,
): value is PaginatedOverrideJustificationArtefactList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedOverrideJustificationArtefactListFromJSON(
  json: any,
): PaginatedOverrideJustificationArtefactList {
  return PaginatedOverrideJustificationArtefactListFromJSONTyped(json, false);
}

export function PaginatedOverrideJustificationArtefactListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedOverrideJustificationArtefactList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(OverrideJustificationArtefactFromJSON),
  };
}

export function PaginatedOverrideJustificationArtefactListToJSON(
  value?: PaginatedOverrideJustificationArtefactList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(OverrideJustificationArtefactToJSON),
  };
}
